<template>
  <div>
    <list-courses @update="update" @create="create()" @remove="remove" @view="view = true" />
    <form-gestion :modal="modal" :external-action="evento" @close="close" />
    <dialog-course :dialog.sync="view" />
  </div>
</template>

<script>
import listCourses from './list'
import formGestion from './formManager'
import DialogCourse from '@/components/apps/tournaments/acceder/DialogCourse'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'dashboard',
  components: {
    listCourses,
    formGestion,
    DialogCourse
  },
  /**
   * Este componente solo tiene dos variables:
   * evento -> controla el evento actual en curso (create,
   * @returns {{evento: string, modal: boolean}}
   */
  data() {
    return {
      modal: false,
      evento: '',
      view: false
    }
  },
  mounted() {
    this.initData()
  },
  computed: {
    ...mapState({
      statusOfButton: state => state.events.status
    })
  },
  methods: {
    ...mapActions({
      clear: 'courses/setClearOne',
      init: 'courses/setInit',
      setStatus: 'events/setStatus',
      teamsInit: 'teams/setInitSelect',
      usersInit: 'users/setInitSelect',
      tournamentInit: 'tournaments/setInitSelect'
    }),
    create() {
      this.nextTick(_ => {
        this.evento = 'create'
      })
      this.modal = true
    },
    update() {
      this.evento = 'update'
      this.nextTick(_ => {
        this.modal = true
      })
    },
    remove() {
      this.evento = 'delete'
      this.nextTick(_ => {
        this.modal = true
      })
    },
    close() {
      this.modal = false
      this.nextTick(_ => {
        this.evento = ''
        this.clear()
      })
    },
    async initData() {
      await Promise.all([
        this.init(),
        this.teamsInit(),
        this.usersInit(),
        this.tournamentInit()
      ])
    }
  },
  watch: {
    statusOfButton: function(val) {
      if (val) this.initData().finally(() => this.setStatus(false))
    }
  }
}
</script>
